import React, { useEffect, useState } from 'react';
import NotifyForm from '@moncler/components/notify/NotifyForm';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { useTranslation } from 'react-i18next';
import formutils from '@utils/formutils';
import classNames from 'classnames';
const StandaloneSubscribeOverlay = (props) => {
    const { t } = useTranslation();
    const [firstRender, setFirstRender] = useState(true);
    const [formSent, setFormSent] = useState(false);
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    useEffect(() => {
        if (firstRender) {
            setFirstRender(false);
            let val = {};
            api.getForm('notifyme', val).then((data) => {
                setInitialValues(val);
                setFormdef(data);
            });
        }
    }, []);
    const prefillValues = (values) => {
        values.eventcode = props.eventcode;
        values.geniuscode = props.geniuscode;
    };
    const validate = async (values) => {
        prefillValues(values);
        return await formutils.validateForm(values, formdef, 'notifyme');
    };
    const onSubmit = async (values) => {
        prefillValues(values);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        const { success } = await api.notifymeNewsletterSubscription(values, formdef);
        if (success) {
            if (props.buildingName) {
                analytics.geniusImmersiveNotifyAction(props.buildingName);
            }
            else if (props.designerName) {
                analytics.geniusExperienceSignUpAction('submit', props.designerName);
            }
            else {
                analytics.getNotificationModalAction(props.type, props.title, 'submit');
            }
            setFormSent(true);
        }
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "product-notify" },
        React.createElement("div", { className: "product-notify__main", style: { backgroundImage: `url("${props.img}")` } }),
        React.createElement("div", { className: "product-notify__detail" }, formSent ? (React.createElement("div", { className: "modal__header-sticky" },
            React.createElement("h2", { className: classNames('dialog__title', { 'mt-32': !props.blackVersion }) }, t('label.thankyou')),
            React.createElement("p", { className: "dialog__message" }, t('notifyme.success')),
            props.blackVersion && (React.createElement("div", { className: "modal__separator" },
                React.createElement("button", { className: "button button--primary", onClick: props.closeCallback }, t('button.back')))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal__header-sticky" },
                React.createElement("h2", { className: "dialog__title" }, props.modaltitle || t('label.notifyme')),
                props.modaltext && React.createElement("p", { className: "modal__intro" },
                    props.modaltext,
                    " "),
                React.createElement("div", { className: "modal__separator" })),
            React.createElement(NotifyForm, { formdef: formdef, onSubmit: onSubmit, initialValues: initialValues, validate: validate, buttonText: props.modalctatext || t('button.submit') }))))));
};
export default StandaloneSubscribeOverlay;
